import { ApisauceInstance } from 'apisauce';
import env from 'env/.public-env.json';

interface ProfileResponse {
  userProfile:
    | {
        roles: FleetOps.Role[] | null;
        permissions: FleetOps.Permission[] | null; // Explicit permissions
      }
    | undefined; // undefined if this uid has no access
  permissions: FleetOps.Permission[]; // Net permissions
}

const getUserAccountAccess = (userId: string, api: ApisauceInstance) =>
  api.get<ProfileResponse>(
    env.PREVIEW
      ? `/v1/preview/user_permissions/users/${userId}`
      : `/v1/user_permissions/users/${userId}`,
  );
export default getUserAccountAccess;
